import { Typography } from "@material-ui/core";
import React from "react";

const SubtitleTable = ({children}) =>{
    return(
        <Typography color='primary' align='center' variant='body2' style={{margin:'20px 0px'}} >{children}</Typography>
    )
}

export default SubtitleTable